// Components
import * as React from 'react';
import { createThemeableComponent, homepageComponents } from 'BaseLayout/themeable-components';
import { SearchContext } from '../../types';
import 'twin.macro';

export interface Props {
  setTopBarVisibility: (visible?: boolean) => void;
  topVisible: boolean;
  searchTerm: string;
  changedSearchTerm: string;
  searchContext: SearchContext;
  onSearchSubmit: (value: string) => void;
  onSearchContextSelect: (context: SearchContext) => void;
  setSearchTerm: (value: string) => void;
  breakpoint?: number;
  children?: any;
}

export function Homepage(props: Props) {

    const ThemedHomepage = createThemeableComponent(homepageComponents);
    return (
      <div>
        <ThemedHomepage {...props} />
      </div>
    );
}

